import { Select, SelectOptionType, TextInput } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { useValidations } from '../../../hooks/useValidations';
import { SectionValuesForm } from './SectionForm';

type SectionFormFieldsProps = {
  campusOptions: SelectOptionType[];
  schedulesOptions: SelectOptionType[];
};

const SectionFormFields = ({
  campusOptions,
  schedulesOptions,
}: SectionFormFieldsProps) => {
  const { t } = useTranslation();
  const prefix = 'sectionsMaintainer.update';
  const { msgValidations, rulesPatternNumeric } = useValidations();

  const { control } = useFormContext<SectionValuesForm>();

  return (
    <Row>
      <Col xs={12} md={4}>
        <TextInput
          name="quota"
          label={t(`${prefix}.quotaLabel`)}
          control={control}
          rules={{
            required: msgValidations.required,
            pattern: rulesPatternNumeric,
          }}
        />
      </Col>
      <Col xs={12} md={4}>
        <Select
          name="campus"
          label={t(`${prefix}.campusLabel`)}
          options={campusOptions}
          control={control}
          rules={{ required: msgValidations.required }}
        />
      </Col>
      <Col xs={12} md={4}>
        <Select
          name="schedule"
          label={t(`${prefix}.schedulesLabel`)}
          options={schedulesOptions}
          control={control}
          isClearable
        />
      </Col>
    </Row>
  );
};

export default SectionFormFields;
